export default __webpack_public_path__ + "static/media/Picture2.22242a44.png";